import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faCalendarAlt, faTimes, faChevronLeft, faTrash } from '@fortawesome/free-solid-svg-icons'

library.add(fab, faCalendarAlt, faTimes, faChevronLeft, faTrash);
